/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Nav_DescInputs */

const en_tut_nav_desc = /** @type {(inputs: Tut_Nav_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step by step, for every way of building`)
};

const id_tut_nav_desc = /** @type {(inputs: Tut_Nav_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langkah demi langkah, untuk semua cara membangun`)
};

/**
* | output |
* | --- |
* | "Step by step, for every way of building" |
*
* @param {Tut_Nav_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_nav_desc = /** @type {((inputs?: Tut_Nav_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Nav_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_nav_desc(inputs)
	return en_tut_nav_desc(inputs)
});